import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const SvgLoading = ({ className, ...props }) => {
  const classes = classNames({
    svg: true,
    'svg-loading': true,
    [className]: className,
  });

  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      className={classes}
      {...props}>
      <path
        className="svg-loading__path svg-loading__path--primary"
        fillRule="evenodd"
        transform="translate(1 10)"
        d="M 2.5 5C 3.88071 5 5 3.88071 5 2.5C 5 1.11929 3.88071 0 2.5 0C 1.11929 0 0 1.11929 0 2.5C 0 3.88071 1.11929 5 2.5 5Z"
      />
      <path
        className="svg-loading__path svg-loading__path--primary"
        fillRule="evenodd"
        transform="translate(9 10)"
        d="M 2.5 5C 3.88071 5 5 3.88071 5 2.5C 5 1.11929 3.88071 0 2.5 0C 1.11929 0 0 1.11929 0 2.5C 0 3.88071 1.11929 5 2.5 5Z"
      />
      <path
        className="svg-loading__path svg-loading__path--primary"
        fillRule="evenodd"
        transform="translate(17 10)"
        d="M 2.5 5C 3.88071 5 5 3.88071 5 2.5C 5 1.11929 3.88071 0 2.5 0C 1.11929 0 0 1.11929 0 2.5C 0 3.88071 1.11929 5 2.5 5Z"
      />
    </svg>
  );
};

SvgLoading.propTypes = {
  className: PropTypes.string,
};

export default SvgLoading;
